export default {

  listeners: [],
  listen: function(f) {
    if (typeof f === "function")
      this.listeners.push(f);
  },
  changed: function() {
    this.listeners.forEach((e) => {
      e();
    })
  }

}
